/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    isWorkOrderSubmitter() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const submitterRoles = this.config.budgetPage.workorderSubmitterRoles;
      return this.memberOf.filter((item) => submitterRoles.includes(item.displayName)).length > 0;
    },
  },
};
